import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=39768eea&scoped=true"
import script from "./Info.ts?vue&type=script&lang=js&external"
export * from "./Info.ts?vue&type=script&lang=js&external"
import style0 from "./Index.less?vue&type=style&index=0&id=39768eea&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39768eea",
  null
  
)

export default component.exports